import type { InstallableApp } from "~/pwa/installableApps";

const rootInstallApp: InstallableApp = {
	description: "",
	icon: "apps",
	key: "worksuite",
	name: "WorkSuite",
	ownedPrefixes: [],
	shortName: "WorkSuite",
	startUrl: "/",
	themeColor: "#385E3A"
};

export default rootInstallApp;
